/* src/app/logo/presenter/logo-presenter.component.scss */
/*# sourceMappingURL=logo-presenter.component.css.map */
